import { contractInput } from '#backend/contract';
import { AsyncPipe } from '@angular/common';
import { Component, inject, input, OnChanges, output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaskDirective } from 'ngx-mask';
import { EnhancedLoadingService } from '../../../shared/services/enhanced-loading.service';
import { SmartOrpcClientService } from '../../../shared/services/smart-orpc-client.service';
import { cnpjValidator } from '../../../shared/utils/cnpj-validator';

type OrgData = contractInput['organization']['create'];
@Component({
  selector: 'app-organization-form',
  imports: [
    AsyncPipe,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    NgxMaskDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './organization-form.component.html',
  styleUrl: './organization-form.component.scss',
})
export class OrganizationFormComponent implements OnChanges {
  orpc = inject(SmartOrpcClientService);
  isLoading = inject(EnhancedLoadingService).isLoad$;

  initialOrg = input<Partial<OrgData>>();
  submit = output<OrgData>();

  orgForm = inject(FormBuilder).nonNullable.group({
    name: [
      '',
      [Validators.required, Validators.minLength(3), Validators.maxLength(160)],
    ],
    cnpj: ['', [Validators.required, cnpjValidator]],
  });

  ngOnChanges(): void {
    const org = this.initialOrg();
    if (org) {
      this.orgForm.patchValue(org);
    }
  }
  checkForErrorsIn(formControl: AbstractControl): string {
    if (formControl.pristine || formControl.valid) return '';

    if (formControl.hasError('required')) {
      return 'Campo obrigatório';
    }

    if (formControl.hasError('cnpj')) {
      return 'CNPJ inválido';
    }
    return 'Valor Inválido';
  }

  async onSubmit() {
    this.orgForm.markAllAsTouched();
    if (this.orgForm.invalid) {
      return;
    }
    this.submit.emit(this.orgForm.getRawValue());
  }
}
